import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { FormWizardCustomFieldAdapter } from '@shared/components/form/form-wizard/form-wizard-field-registry.service';
import { FormFieldConfig } from '@shared/components/form/form-wizard/models/form-wizard.models';
import { InvestmentDescriptionEnhancedComponent } from '@shared/components/form/investment-description-enhanced/investment-description-enhanced.component';

@Component({
  selector: 'app-investment-description-form-field',
  standalone: true,
  imports: [ReactiveFormsModule, InvestmentDescriptionEnhancedComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-investment-description-enhanced
      [formControl]="control"
      [disabled]="field.disabled || false"
      [readonly]="field.readonly || false"
    />
  `,
})
export class InvestmentDescriptionFormFieldComponent
  implements FormWizardCustomFieldAdapter {
  @Input({ required: true }) field!: FormFieldConfig;
  @Input({ required: true }) form!: FormGroup;

  get control(): FormControl {
    return this.form.get(this.field.key) as FormControl;
  }
}
